"use client";

import dynamic from "next/dynamic";
import { Link } from "@/navigation";
import { renderClassName } from "@/utils/renderClassName";
import { sendGTMEvent } from "@next/third-parties/google";

const DynamicSparkles = dynamic(() => import("../Sparkles"), { ssr: false });

type ButtonProps = {
  type: "primary" | "secondary" | "soon";
  mode?: "dark";
  classNames?: string;
  children: React.ReactNode;
  isLink?: boolean;
  href?: string;
  isTargetBlank?: boolean;
  isTop?: boolean;
  isDownload?: boolean;
  event?: Object;
  onClick?: VoidFunction;
  disabled?: boolean;
};

const Button = ({
  type,
  mode,
  classNames,
  isLink,
  event,
  href,
  isDownload,
  isTargetBlank,
  isTop,
  onClick,
  disabled,
  children,
}: ButtonProps) => {
  const renderClassNameBaseOnType =
    type === "primary"
      ? "button button-primary"
      : type === "soon"
      ? "button button-soon"
      : "button button-secondary";

  const renderClassNameBaseOnMode = mode === "dark" ? "button--dark" : "";

  if (isLink && !href) {
    throw new Error("If a component is a link you need to set href value");
  }
  if (isLink && isDownload) {
    return (
      <div className="button-container">
        <Link
          href={href!}
          target={isTargetBlank ? "_blank" : "_self"}
          download
          onClick={() => {
            onClick && onClick();
            if (
              process.env.NEXT_PUBLIC_MEASUREMENT_ID &&
              process.env.NODE_ENV === "production" &&
              event
            ) {
              sendGTMEvent(event);
            }
            return true;
          }}
          className={renderClassName(
            `${renderClassNameBaseOnType} ${renderClassNameBaseOnMode}`.trim(),
            classNames
          )}
        >
          {children}
        </Link>
        <DynamicSparkles />
      </div>
    );
  }
  if (!isLink) {
    return (
      <div className="button-container">
        <button
          disabled={disabled}
          onClick={() => {
            onClick && onClick();
            if (
              process.env.NEXT_PUBLIC_MEASUREMENT_ID &&
              process.env.NODE_ENV === "production" &&
              event
            ) {
              sendGTMEvent(event);
            }
            return true;
          }}
          className={renderClassName(
            `${renderClassNameBaseOnType} ${renderClassNameBaseOnMode}`.trim(),
            classNames
          )}
        >
          {children}
        </button>
        <DynamicSparkles />
      </div>
    );
  } else {
    return (
      <div className="button-container">
        <Link
          onClick={() => {
            onClick && onClick();
            if (
              process.env.NEXT_PUBLIC_MEASUREMENT_ID &&
              process.env.NODE_ENV === "production" &&
              event
            ) {
              sendGTMEvent(event);
            }
            return true;
          }}
          locale="ru"
          href={href!}
          target={isTargetBlank ? "_blank" : isTop ? "_top" : "_self"}
          className={renderClassName(
            `${renderClassNameBaseOnType} ${renderClassNameBaseOnMode}`.trim(),
            classNames
          )}
        >
          {children}
        </Link>
        <DynamicSparkles />
      </div>
    );
  }
};

export default Button;
